import { Table } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../../../../components";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../../../plugins/utils";
import { useComission } from "../../../../context/ComissionContext";
import { useGetAgentWinLoss } from "../../../../hooks/comissionreport.hooks";
import styles from "./style.module.scss";

const CURRENCY = getCurrency();

const WinLoss = ({}) => {
  const { t } = useTranslation();
  const { selectedMonth, agentBonusId, selectedWeek } = useComission();

  const [summary, setSummary] = useState(0);
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading, isError, error } =
    useGetAgentWinLoss({
      params: {
        // period_month: selectedMonth.value,
        period_date: selectedWeek?.value?.split("~")[0],
      },
      agent_bonus_id: agentBonusId,
      options: {
        enabled: selectedWeek !== null && agentBonusId !== null,
        getNextPageParam: (lastPage, pages) => {
          if (pages.length < lastPage.last_page) {
            return pages.length + 1;
          } else {
            return undefined;
          }
        },
      },
    });
  const [localData, setLocalData] = useState([]);

  const columns = [
    {
      title: t("comission.table.account"),
      width: 100,
      align: "center",
      dataIndex: "account",
    },
    {
      title: t("comission.table.UID"),
      width: 100,
      align: "center",
      dataIndex: "account_id",
    },
    {
      title: `${t("comission.table.winloss")} (${t(`global.currency.${CURRENCY}`)})`,
      align: "center",
      width: 100,
      dataIndex: "total_win_loss_amount",
      search: false,
      render: (text, record, index) => (
        <div className={`${styles.amount} ${text <= 0 ? styles.redColor : styles.greenColor}`}>
          {moneyFormat(text)}
        </div>
      ),
    },
  ];

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (data) {
      const page_length = data.pages.length;
      if (page_length <= 1) {
        setLocalData([...data.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...data.pages[page_length - 1].data];
        });
      }
      const totalWinLoss = data.pages[page_length - 1].data.reduce(
        (sum, a) => sum + (a.total_win_loss_amount || 0),
        0,
      );
      setSummary(totalWinLoss);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      {isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={agentBonusId !== null}
          summary={() => {
            return (
              <Table.Summary fixed="top">
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <div className={styles.summaryCell}>{t("normal.summary")}</div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} />
                  <Table.Summary.Cell index={2}>
                    <div
                      className={`${styles.summaryCell} ${styles.content} ${
                        summary <= 0 ? styles.redColor : styles.greenColor
                      }`}
                    >
                      {moneyFormat(summary || 0)}
                    </div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} />
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      )}
    </div>
  );
};

export default WinLoss;
